import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

@Component({
  selector: 'app-sales-office-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex flex-col gap-1">
      <!-- <span class="text-sm font-semibold text-gray-600 dark:text-gray-300">{{ code }}</span> -->
      <span class="text-sm">{{ name }}</span>
    </div>
  `,
  styles: [`:host { display: block; width: 100%; }`]

})
export class SalesOfficeCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  // get code(): string {
  //   return this.params?.data?.salesOffice?.externalKeys?.code ?? '-';
  // }

  get name(): string {
    return this.params?.data?.salesOffice?.name ?? '-';
  }
}
